import React, { useCallback, useEffect, useState, useContext } from "react";
import Input from "../parts/Input";
import Select from "../../components/Select";
import RoundProgress from "../../components/RoundProgress";
import InfoButton from "../../partials/Form/InfoButton";
import Controls from "../parts/Controls";
import { Web3Context } from "../../contexts/Web3Context";
import { removeDecimal } from "../../apis/utils";
import { BigNumber, ethers } from "ethers";
import * as blockchainApi from "../../apis/blockchain";
import axios from "axios";
import CrossCloseButton from "../parts/CrossCloseButton";
import InfoButtonMobile from "../../partials/Form/InfoButtonMobile";

export default function ({ data, asset }) {
  const Swal = require("sweetalert2");
  const [collatAsset, setCollatAsset] = useState({});
  const [collatAssetName, setCollatAssetName] = useState("");
  const [collatMax, setCollatMax] = useState(0);
  const [loanHealth, setLoanHealth] = useState("green");
  const [loanData, setLoanData] = useState({});
  const [allowance, setAllowance] = useState(0);
  const [recollateralize, setRecollateralizing] = useState(false);
  const [approving, setApproving] = useState(false);

  let web3Context = useContext(Web3Context);
  const list = [{
      id: 0,
      type: "Original Collateralization Ratio",
      ratio: asset.collatRatio / 100,
      info: "The collateral ratio you borrowed at.",
    },
    {
      id: 1,
      type: "Actual Collateralization Ratio",
      ratio:
        asset.collateralValue != 0
          ? asset.collateralValue
              .mul(100)
              .div(asset.usdBorrowBalance)
              .toString()
          : "0",
      info: "Your current collateral ratio.",
    },
    
    {
      id: 2,
      type: "Minimum Collateralization Ratio",
      ratio: 130,
      info: "You will have 24 hours to repay/loan Status.",
    },
    {
      id: 3,
      type: "All Collateral Liquidation Collateralization Ratio",
      ratio: 110,
      info: "You will be liquidated instantly.",
    },
  ];

  const [formData, setFormData] = data;
  const [ww, setWW] = useState(window.innerWidth);

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resizeHandler = useCallback((e) => {
    const sizes = [530];
    const current = window.innerWidth;

    if (sizes.find((size) => current < size)) {
      setWW(current);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);

    () => window.removeEventListener("resize", resizeHandler);
  }, []);

  const handleEmail = async (e) => {
    e.preventDefault();

    console.log("test");
    const urlSet =
      "https://us-central1-rasko-backend.cloudfunctions.net/email" +
      "?account=" +
      web3Context.currentAccountAddress +
      "&email=" +
      formData.email;

    await axios.post(urlSet);
    console.log(web3Context.currentAccountAddress);

    const urlGet =
      "https://us-central1-rasko-backend.cloudfunctions.net/fetchData" +
      "?account=" +
      web3Context.currentAccountAddress +
      "&mmi=" +
      asset.mmi.address;
    const dataGet = await axios.get(urlGet);
    setLoanData(dataGet.data);
    console.log(dataGet.data);
  };

  const handleApprove = async (e) => {
    e.preventDefault();

    try {
      setApproving(true);
      const approveTx = await collatAsset.approve(
        asset.mmi.address,
        ethers.constants.MaxUint256
      );
      await approveTx.wait();
    } catch (error) {
      setApproving(false);
      return;
    }
    Swal.fire({
      text: "Approve successful.",
      icon: "success",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setApproving(false);
    return;
  };

  const handleRecollateralize = async (e) => {
    e.preventDefault();
    // inform user if web3 not initialized
    if (web3Context.currentAccountAddress == "") {
      // alert("You are not connected. Connect and try again.");
      Swal.fire({
        text: "You are not connected. Connect and try again.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (asset.collateralLockedALR == ethers.constants.AddressZero) {
      // alert("No existing loan.");
      Swal.fire({
        text: "No existing loan.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    const accountBalance = await blockchainApi.getERC20Balance(
      collatAsset,
      web3Context.currentAccountAddress
    );

    let requestedRecollateralize =
      formData.asset === ""
        ? ethers.utils.parseEther("0")
        : collatAsset.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
        ? ethers.utils.parseUnits(formData.asset.toString(), 6)
        : ethers.utils.parseEther(formData.asset.toString());

    // must have enough balance
    if (accountBalance.lt(requestedRecollateralize)) {
      // alert("Insufficient token balance.");
      Swal.fire({
        text: "Insufficient token balance.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let max =
      collatAsset.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8"
        ? ethers.utils.parseUnits(collatMax, 6)
        : ethers.utils.parseEther(collatMax);

    if (max.lt(requestedRecollateralize)) {
      // alert("Recollateralizing too much.");
      Swal.fire({
        text: "Loan Status too much.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      setRecollateralizing(true);
      let recollateralizeTx = await asset.mmi.recollateralize(
        requestedRecollateralize,
        asset.collateralLockedALR
      );
      await recollateralizeTx.wait();

      const urlSet =
        "https://us-central1-rasko-backend.cloudfunctions.net/repay" +
        "?account=" +
        web3Context.currentAccountAddress +
        "&mmi=" +
        asset.mmi.address;
      await axios.post(urlSet);
    } catch (error) {
      setRecollateralizing(false);
      return;
    }
    Swal.fire({
      text: "Loan Status successful.",
      icon: "success",
      confirmButtonText: '<a href="/trade">OK</a>',
    });
    setRecollateralizing(false);
  };

  // upon open
  useEffect(async () => {
    if (asset.collateralLockedALR != ethers.constants.AddressZero) {
      let collateralLockedAsset = await asset.collateralLockedContract.asset();
      let collateralLockedAssetContract = await blockchainApi.getAssetContract(
        web3Context.web3.web3Provider,
        collateralLockedAsset
      );
      let collateralLockedAssetName =
        await collateralLockedAssetContract.name();

      let collatRemainingUSD = asset.usdBorrowBalance
        .mul(asset.collatRatio.toString())
        .div(10000)
        .sub(asset.collateralValue);

      let collatRemaining =
        await web3Context.web3.uniswapOracleFactoryContract.viewUnderlyingAssetPriceOfwETH(
          asset.mmi.address,
          collatRemainingUSD
        );

      if (asset.address == "0xAC51066d7bEC65Dc4589368da368b212745d63E8") {
        collatRemaining = ethers.utils.formatUnits(collatRemaining, 6);
      } else {
        collatRemaining = ethers.utils.formatEther(collatRemaining);
      }

      if (
        parseInt(
          asset.collateralValue.mul(100).div(asset.usdBorrowBalance).toString()
        ) <= 130
      ) {
        setLoanHealth("red");
      }

      const urlGet =
        "https://us-central1-rasko-backend.cloudfunctions.net/fetchData" +
        "?account=" +
        web3Context.currentAccountAddress +
        "&mmi=" +
        asset.mmi.address;
      const dataGet = await axios.get(urlGet);

      const collatAllowance = await collateralLockedAssetContract.allowance(
        web3Context.currentAccountAddress,
        asset.mmi.address
      );

      setCollatAssetName(collateralLockedAssetName);
      setCollatAsset(collateralLockedAssetContract);
      setCollatMax(collatRemaining);
      setLoanData(dataGet.data);
      setAllowance(collatAllowance);
    }
  }, []);

  return (
    <>
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <div className="modal-form recollateralize">
        <form className="modal-form">
          <div className="modal-form__item">
            <div className="recollateralize-info">
              <div className="recollateralize-info__item">
                <div className="recollateralize-info__circle">
                  <div className={"recollateralize-info__circle-" + loanHealth}>
                    <span>Loan Health</span>
                  </div>
                  <InfoButton
                    className="recollateralize-info__info-btn"
                    marginBottom={10}
                    posX="center"
                  >
                    {loanHealth == "green"
                      ? "Your loan is healthy."
                      : "Your time remaining to repay/recollateralize is on the left."}
                  </InfoButton><InfoButtonMobile text={loanHealth == "green"
                      ? "Your loan is healthy."
                      : "Your time remaining to repay/recollateralize is on the left."} />
                </div>
              </div>
              <div className="recollateralize-info__item recollateralize-info__item_txt">
                <div className="recollateralize-info__block">
                  <h3 className="recollateralize-info__title">
                    Time Remaining Until Liquidation &nbsp;{" "}
                    <InfoButton marginBottom={10} textAlign="left" posX="left">
                      Unless repaid or price rebounds, a quantity of your
                      collateral will be liquidated to bring your Actual
                      Collateralization Ratio to Original Collateralization
                      Ratio when this timer runs out. Repay to avoid
                      liquidation.
                    </InfoButton>
                    <InfoButtonMobile text="Unless repaid or price rebounds, a quantity of your collateral will be liquidated to bring your Actual Collateralization Ratio to Original Collateralization Ratio when this timer runs out. Repay to avoid liquidation." />
                  </h3>
                  <div className="recollateralize-info__circle">
                    <RoundProgress
                      current={
                        loanHealth == "green"
                          ? "--"
                          : removeDecimal(
                              (loanData.liqCountdown - Date.now()) / 3600000
                            )
                      }
                      max={24}
                      subtext="Hours"
                    />
                    <InfoButton
                      className="recollateralize-info__info-btn"
                      marginBottom={10}
                      posX="center"
                    >
                      {loanHealth == "green"
                        ? "Your loan is healthy."
                        : "You will be liquidated if you dont repay/loan Status within the timelimit"}
                    </InfoButton><InfoButtonMobile text={loanHealth == "green"
                        ? "Your loan is healthy."
                        : "You will be liquidated if you dont repay/loan Status within the timelimit"} />
              &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-form__item recollateralize__table">
            <div className="r-table">
              <div className="r-table__row r-table__row_title">
                <div className="r-table__col">
                  <div className="r-table__type">
                    Collateralization Ratio Type
                  </div>
                </div>
                <div className="r-table__col">
                  <div className="r-table__type">Collateralization Ratio</div>
                </div>
              </div>
              <div className="r-table__list">
                {list.map((item) => (
                  <div className="r-table__row" key={item.id}>
                    <div className="r-table__col">
                      <span className="r-table__type">{item.type}</span>
                      <InfoButton className="r-table__info">
                        {item.info}
                      </InfoButton>
                      <InfoButtonMobile text={item.info} />
                    </div>
                    <div className="r-table__col">
                      <div className="r-table__percent">{item.ratio}%</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="modal-form__item recollateralize__email recollateralize__item_m27">
            <span>
              Current Email: &nbsp;{" "}
              <InfoButton marginBottom={10} textAlign="left" posX="left">
                Enter your email address to recieve and email notification
                if/when Minimum Collateralization Ratio is reached.
              </InfoButton>
              <InfoButtonMobile text="Enter your email address to recieve and email notification if/when Minimum Collateralization Ratio is reached." />
              &nbsp; {loanData.email}
            </span>
            <div className="modal-form__field modal-form__field_nmt">
              <Input
                type="text"
                placeholder="Undercollateralization Email Notification - Enter Email"
                name="email"
                value={formData.email}
                onChange={changeHandler}
              />
            </div>
            <button
              className="recollateralize__submit-email"
              onClick={handleEmail}
            >
              Submit Email Address
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
